export const debugHelpers = async (err) => {
    if (err) {
        console.error(err);
    }



    /*
     * Show current screen resolution in dev mode
     */
    if (
        window.location.origin.endsWith('.local') ||
        window.location.origin.endsWith('.local:3000')
    ) {
        const infoBoxSR = document.createElement('div');
        infoBoxSR.className = 'screen-resolution';
        document.getElementsByTagName('body')[0].appendChild(infoBoxSR);
        infoBoxSR.innerHTML = window.innerWidth + 'x' + window.innerHeight;
        //window.addEventListener('resize', showScreenRes);

        const infoBoxSR_Resize = document.querySelector('.screen-resolution');

        // Change values when window is resized
        window.onresize = function () {
            infoBoxSR_Resize.innerHTML = window.innerWidth + 'x' + window.innerHeight;
        };
    }



};

import.meta.webpackHot?.accept(debugHelpers);